import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jinyong",
  "use": "icon-jinyong-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-jinyong\">\n<path d=\"M100,0C44.8,0,0,44.8,0,100s44.8,100,100,100s100-44.8,100-100C199.9,44.8,155.2,0.1,100,0z M184.9,100\n\tc0,19.8-6.9,39.1-19.7,54.3L45.7,34.7c36-30,89.6-25.1,119.6,10.9C178,60.9,185,80.1,184.9,100z M15.1,100\n\tc0-19.8,6.9-39.1,19.7-54.3l119.6,119.6c-36,30-89.6,25.1-119.6-10.9C22,139.1,15,119.9,15.1,100z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol